import { LogNotification, LogNotifyType } from '@/api';
import { parseNotificationEvent } from './notificationStream';

type NotificationStreamSubscriber = {
    onNotification: (notification: LogNotification) => void;
    onReconnect?: () => void;
};

const NOTIFICATION_EVENT_TYPES = [
    LogNotifyType.NOTIFY_TYPE_GAME,
    LogNotifyType.NOTIFY_TYPE_BROADCAST,
    LogNotifyType.NOTIFY_TYPE_TOURNAMENT,
    LogNotifyType.NOTIFY_TYPE_PAYMENT,
];

const subscribers = new Set<NotificationStreamSubscriber>();
let stream: EventSource | undefined;
let hasConnected = false;

const stopStream = () => {
    stream?.close();
    stream = undefined;
    hasConnected = false;
};

const startStream = () => {
    if (stream) return;

    stream = new EventSource('/api/v1/notify/stream');
    const handleNotification = (event: MessageEvent<string>) => {
        const notification = parseNotificationEvent(event.data);
        if (!notification) return;
        [...subscribers].forEach((subscriber) => subscriber.onNotification(notification));
    };
    const handleOpen = () => {
        if (hasConnected) {
            [...subscribers].forEach((subscriber) => subscriber.onReconnect?.());
        }
        hasConnected = true;
    };

    NOTIFICATION_EVENT_TYPES.forEach((type) => stream?.addEventListener(type, handleNotification));
    stream.addEventListener('open', handleOpen);
};

export const subscribeNotificationStream = (subscriber: NotificationStreamSubscriber) => {
    subscribers.add(subscriber);
    startStream();

    return () => {
        subscribers.delete(subscriber);
        if (subscribers.size === 0) stopStream();
    };
};
